<template>
  <div class="endemett" style="width: 98%;margin: 0 auto;">
    <el-card shadow="always">
      <div style="border: 1px solid #ccc;">
        <el-row :gutter="24" style="background:#f1f1f1;margin:0px;padding: 10px 0;">
          <el-col :span="16">
            <div class="cente">
              <el-col :span="2" style="min-width: 110px;">
                <el-image
                  :src="room.room.avatar"
                  :preview-src-list="room.room.pictures"
                  style="width: 100px; height: 100px" />
              </el-col>
              <el-col :span="21">
                <el-col :span="12">
                  <p class="fontsize14">参会人数:{{ room.number }}人</p>
                  <div style="margin-top:10px;" class="fontsize14">
                    会议地点:{{ room.address.city }}{{ room.address.address }}
                  </div>
                  <div style="margin-top:10px;" class="fontsize14">会议室: {{ room.room.name }} - {{ room.room.area }}
                  </div>
                </el-col>
              </el-col>
            </div>
          </el-col>
          <el-col :span="8" style="overflow: auto;">
            <div style="margin-top: 10px;float:right;margin-right: 30px;">
              <el-button type="primary" size="small" @click="sub(&quot;form&quot;)">确认修改</el-button>
            </div>
          </el-col>
        </el-row>
        <el-divider>
          <i class="el-icon-collection-tag" />
        </el-divider>
        <el-form ref="form" :model="form" :rules="rules" label-width="120px" style="padding: 10px;">
          <el-row :gutter="24">
            <div style="margin-left: 10px;">
              <meeting-time :roomid="room_id" :isList="false" @reload="meetingTimeReload" />
            </div>
            <el-divider><i class="el-icon-collection-tag" /></el-divider>
            <el-col :span="12">
              <el-form-item label="选择时间为:">
                <span v-if="room.estimate_start_time!=''" style="font-size: 18px;">{{ form.estimate_start_time }}~
                  {{ form.estimate_end_time }}</span>
              </el-form-item>
              <el-form-item label="保密类型" prop="secrecy_type">
                <el-radio-group v-model="form.secrecy_type">
                  <el-radio :label="0">普通会议（非保密）</el-radio>
                  <el-radio :label="1">一级会议（保密）</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="是否需要评分" prop="is_need_score">
                <el-radio-group :disabled="meeting_status !== 0" v-model="form.is_need_score">
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="2">否</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="会议类型" prop="type_id" class="fdg">
                <el-select v-model="form.type_id" disabled placeholder="请选择会议类型">
                  <el-option v-for="item in meetingoptions" :key="item.id" :label="item.type_name" :value="item.id" />
                </el-select>
              </el-form-item>
              <el-form-item v-if="needDepart" label="所属部门" prop="secretary_department_id" class="fdg">
                <el-select v-model="form.secretary_department_id" placeholder="请选择部门" @change="getChange">
                  <el-option
                    v-for="(item,index) in departmentList"
                    :key="index"
                    :label="item.department"
                    :value="item.id" />
                </el-select>
              </el-form-item>
              <el-form-item label="会议室" prop="room_id" class="fdg" required>
                <el-select v-model="form.room_id" filterable remote reserve-keyword @change="roomChange">
                  <el-option v-for="item in roomList" :key="item.id" :label="item.name" :value="item.id" />
                </el-select>
              </el-form-item>
              <el-form-item label="召集人" class="fdg" prop="convenor_user_ids">
                <el-select
                  v-model="form.convenor_user_ids"
                  :remote-method="remoteMethod"
                  :disabled="desleb"
                  :loading="loading"
                  filterable
                  remote
                  reserve-keyword
                  placeholder="请输入姓名"
                  @change="(val => {selectByType(val, 'convenor')})"
                 >
                  <el-option
                    v-for="item in personInChargeList"
                    :key="item.username"
                    :label="item.label+'('+item.value+')'"
                    :value="item" />
                </el-select>
              </el-form-item>
              <el-form-item label="主持人" class="fdg" prop="host_user_id">
                <el-select
                  v-model="form.host_user_id"
                  :remote-method="remoteMethod"
                  :disabled="desleb"
                  :loading="loading"
                  filterable
                  remote
                  reserve-keyword
                  placeholder="请输入姓名"
                  @change="(val => {selectByType(val, 'host')})">
                  <el-option
                    v-for="item in personInChargeList"
                    :key="item.username"
                    :label="item.label+'('+item.value+')'"
                    :value="item" />
                </el-select>
              </el-form-item>
              <el-form-item label="会议秘书" class="fdg" prop="secretary_user_id">
                <el-select
                  v-model="form.secretary_user_id"
                  :remote-method="remoteMethod"
                  :disabled="desleb"
                  :loading="loading"
                  filterable
                  remote
                  reserve-keyword
                  placeholder="请输入姓名"
                  @change="(val => {selectByType(val, 'secretary')})">
                  <el-option
                    v-for="item in personInChargeList"
                    :key="item.username"
                    :label="item.label+'('+item.value+')'"
                    :disabled="item===form.convenor_user_ids"
                    :value="item" />
                </el-select>
              </el-form-item>
              <el-form-item label="参会人员">
            <div style="min-height: 40px; width: 430px;border: 1px solid #dcdfe6;
              border-radius: 4px;cursor: pointer; line-height: 30px;" @click="selectUser">
              <span v-if="userList.length===0" style="margin-left: 15px; color: #b2b2b2;">请选择人员</span>
              <el-tag v-for="(item, index) in userList" :key="item.userId"
                closable @close="removeUser(index)" style="margin-left:5px;height:22px;line-height:22px;">
                {{ item.name }}({{ item.username }})
              </el-tag>
            </div>
          </el-form-item>
              <el-form-item label="提醒时间" class="fdg" prop="reminder_time">
                <el-select v-model="form.reminder_time" :disabled="desleb" placeholder="请选择提醒时间">
                  <el-option label="无提醒" value="0" />
                  <el-option label="开会前5分钟提醒" value="5" />
                  <el-option label="开会前15分钟提醒" value="15" />
                  <el-option label="开会前30分钟提醒" value="30" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="会议主题" prop="subject">
                <el-input v-model="form.subject" :disabled="desleb" placeholder="请输入内容" />
              </el-form-item>
              <el-form-item label="会议描述">
                <el-input
                  :autosize="{ minRows: 2}"
                  v-model="form.describe"
                  :disabled="desleb"
                  type="textarea"
                  placeholder="请输入内容" />
              </el-form-item>
              <el-form-item v-for="(domain, index) in room.lssue" :label="'会议议题'" :key="domain.index" prop="lssue">
                <el-input v-model="domain.value">
                  <template v-if="index !== 0" slot="append">
                    <i class="el-dialog__close el-icon el-icon-close" @click.prevent="removeDomain(domain)" />
                  </template>
                </el-input>
              </el-form-item>
              <p style="text-align: center;">
                <el-button type="success" icon="el-icon-circle-plus-outline" circle @click="addDomain" />
              </p>
              <div style="margin-top: 10px;">
                <el-button size="small" type="primary" @click="sub(&quot;form&quot;)">确认修改</el-button>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>

     <!-- 人员选择 -->
    <user-conf v-bind.sync="selectObj" @save="saveUsre"></user-conf>
  </div>
</template>

<script>
import {
  gituser,
  gitusers,
  getDDusers,
  getDepartTree
} from '@/api/user'
import {
  meetingtype,
  meetingupdate
} from '@/api/conferencebooking'

import {
  meetingid
} from '@/api/seedetails'
import meetingTime from '@/components/meetingTime'
import { searchRoom } from '@/api/meetingTemplate'
import { getUserInfoById } from '@/api/login'
import { getAllSecretary } from '../../api/secretary'
import userConf from '@/components/selectPerson'

export default {
  components: {
    meetingTime, userConf
  },
  data() {
    return {
      meetingoptions: [],
      room: {
        address: {},
        room: {}
      },
      formInline: {},
      username: [],
      estimate_start_time: '',
      estimate_end_time: '',
      usernames: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      list: [],
      loading: false,
      users: [],
      curLists: [],
      personInChargeList: [],
      data: '',
      form: {
        lssue: [{
          value: ''
        }],
        subject: '',
        describe: '',
        radio: '1',
        type: '',
        secrecy_type: null,
        urgency: '',
        contact_user_id: '',
        convenor_user_id: '',
        host_user_id: '',
        secretary_user_id: '',
        attendees: [],
        reminder_time: '5',
        department: '',
        isdata: [],
        secretary_department_id: 0
      },
      desleb: false,
      nubm: 0,
      roomList: [],
      room_id: '', // 监控这个值，使时间组件从而改变
      rules: {
        type_id: [{
          required: true,
          message: '请选择会议类型',
          trigger: 'change'
        }],
        urgency: [{
          required: true,
          message: '请选择紧急程度',
          trigger: 'change'
        }],
        contact_user_id: [{
          required: true,
          message: '请选择联系人',
          trigger: 'change'
        }],
        convenor_user_ids: [{
          required: true,
          message: '请选择召集人',
          trigger: 'change'
        }],
        host_user_id: [{
          required: true,
          message: '请选择主持人',
          trigger: 'change'
        }],
        secretary_user_id: [{
          required: true,
          message: '请选择会议秘书',
          trigger: 'change'
        }],
        reminder_time: [{
          required: true,
          message: '请选择提醒时间',
          trigger: 'change'
        }],
        subject: [{
          required: true,
          message: '请输入会议主题',
          trigger: 'blur'
        }],
        lssue: [
          {
            required: true,
            message: '请输入会议议题',
            trigger: 'change'
          }
        ],
        describe: [{
          required: true,
          message: '请输入会议描述',
          trigger: 'blur'
        }],
        secretary_department_id: [{
          required: true,
          message: '请选择关联部门',
          trigger: 'change'
        }],
        is_need_score: [{
          required: true,
          message: '请选择是否需要评分',
          trigger: 'change'
        }]
      },
      departmentList: [], // 所有部门列表
      needDepart: false,
      selectObj: {
        visible: false,
        allUser: [],
        departTree: [],
        hasChoosed: [],
        mettingUser: [], // 会议原有的参会人
        meeting_status: 0// 会议状态
      },
      allUser: [], // 全部员工
      userList: [],
      departTree: [],
      meeting_status: 0
    }
  },
  created() {
    searchRoom({ page_size: 1000, room_status: 1 }).then(res => {
      this.roomList = res.code === 'success' ? res.data.rooms : []
    })
    this.getPerson(0)
    this.getDepart()
  },
  mounted() {
    const user = {
      name: this.$store.getters.name,
      username: this.$store.getters.username,
      userId: this.$store.getters.userId
    }
    this.username.push(user)
    this.form.room_id = this.$route.query.id
    const data = {
      departmentId: 0
    }
    const p1 = new Promise((resolve, reject) => {
      const params = {
        is_available: 1,
        page: 1,
        page_size: 10000
      }
      getAllSecretary(params).then(res => {
        console.log(res)
        if (res.code === 'success' && res.data && res.data.secretary) {
          this.departmentList = res.data.secretary
          this.departmentList.unshift({ id: 0, department: '请选择部门' })
        } else {
          this.departmentList = []
        }
        resolve()
      }).catch(() => {
        reject()
      })
    })

    const p2 = new Promise((resolve, reject) => {
      gituser().then(response => {
        const dict_str = response.data
        this.read_json_only(dict_str)
        resolve()
      }).catch(err => {
        console.log(err)
        reject()
      })
    })

    const p3 = new Promise((resolve, reject) => {
      gitusers(data).then(response => {
        this.users = response.data
        this.list = this.users.map(item => {
          return {
            value: item.username,
            label: item.name,
            id: item.userId
          }
        })
        resolve()
      }).catch(err => {
        console.log(err)
        reject()
      })
    })

    const p4 = new Promise((resolve, reject) => {
      meetingtype().then(response => {
        this.meetingoptions = response.data.types
        resolve()
      }).catch(err => {
        console.log(err)
        reject()
      })
    })

    Promise.all([p1, p2, p3, p4]).then(res => {
      this.getmeetingsearch(this.$route.query.id)
    }).catch(err => {
      console.log(err)
    })
  },
  methods: {
    getChange(val) {
      this.$forceUpdate()
    },
    checkType() {
      this.needDepart = false
      this.meetingoptions.forEach(item => {
        if (item.id === this.form.type_id && item.is_department === 1) {
          this.needDepart = true
        }
      })
    },
    getDepartment() {
      const params = {
        is_available: 1,
        page: 1,
        page_size: 10000
      }
      getAllSecretary(params).then(res => {
        if (res.code === 'success' && res.data && res.data.secretary) {
          this.$set(this, 'departmentList', res.data.secretary)
        } else {
          this.departmentList = []
        }
      })
    },
    getmeetingsearch(data) {
      meetingid(data)
        .then(response => {
          for (let index = 0; index < response.data.meeting.lssue.length; index++) {
            const ss = { value: response.data.meeting.lssue[index] }
            response.data.meeting.lssue[index] = ss
          }
          this.meeting_status = response.data.meeting.meeting_status
          if (response.data.meeting.meeting_status === 1) {
            this.desleb = true
          }
          this.room = response.data.meeting
          response.data.meeting.attendees.forEach(item => {
            item.username = item.workcode
          })
          this.userList = response.data.meeting.attendees
          this.mettingUser = response.data.meeting.attendees // 会议本身选中的人，针对编辑时不能删除这些人
          this.form = {
            type_id: Number(response.data.meeting.meeting_type_id),
            estimate_start_time: response.data.meeting.estimate_start_time,
            estimate_end_time: response.data.meeting.estimate_end_time,
            night_estart_time: response.data.meeting.night_estart_time,
            night_eend_time: response.data.meeting.night_eend_time,
            secrecy_type: response.data.meeting.secrecy_type,
            convenor_user_ids: response.data.meeting.convenor.name,
            convenor: response.data.meeting.convenor,
            host_user_id: response.data.meeting.host.name,
            host: response.data.meeting.host,
            secretary_user_id: response.data.meeting.secretary.name,
            secretary: response.data.meeting.secretary,
            subject: response.data.meeting.meeting_subject,
            describe: response.data.meeting.describe,
            reminder_time: response.data.meeting.reminder_advance_time.toString(),
            attendees: response.data.meeting.attendees,
            usernames: response.data.meeting.attendees,
            lssue: response.data.meeting.lssue,
            room_id: response.data.meeting.meeting_room_id,
            is_need_score: response.data.meeting.is_need_score
          }
          // 通过会议类型ID判断是否显示部门关联
          this.needDepart = false
          this.form.secretary_department_id = 0
          this.meetingoptions.forEach(item => {
            if (item.id === Number(response.data.meeting.meeting_type_id)) {
              if (item.is_department === 1) {
                this.needDepart = true
                this.form.secretary_department_id = response.data.meeting.secretary_department_id === 0 ? 0 : response.data.meeting.secretary_department_id
              }
            }
          })
          if (response.data.meeting.department_id) {
            this.form.department_id = response.data.meeting.department_id
          }// 如果没有部门id，又后台没存userid 没法去查部门（以前的数据）
        })
        .catch(err => {
          console.log(err)
        })
    },
    selectByType(val, type) {
      const data = {
        name: val.label,
        username: val.value
      }
      if (type === 'convenor') {
        if (!val) {
          this.personInChargeList = []
        } else {
          getUserInfoById(val.id).then((res) => {
            if (res && res.data) {
              this.form.department_id = res.data.departmentId // 召集人的部门
            }
          }).catch()
          // 处理首次选择召集人，默认为主持人
          if (this.nubm === 0) {
            this.form.host_user_id = val.label + '(' + val.value + ')'
            this.nubm++
          }
        }
        if (this.convenor_user_ids && this.username.indexOf(this.convenor_user_ids) !== -1) {
          this.username.splice(this.username.indexOf(this.convenor_user_ids), 1)
        }
        this.convenor_user_ids = data
      } else if (type === 'host') {
        if (this.host_user_id && this.username.indexOf(this.host_user_id) !== -1) {
          this.username.splice(this.username.indexOf(this.host_user_id), 1)
        }
        this.host_user_id = data
      } else {
        if (this.secretary_user_id && this.username.indexOf(this.secretary_user_id) !== -1) {
          this.username.splice(this.username.indexOf(this.secretary_user_id), 1)
        }
        this.secretary_user_id = data
      }
      if (this.username.map(item => item.username).indexOf(data.username) === -1) {
        this.username.push(data)
      }
    },
    handleClose(tag) {
      this.usernames.splice(this.usernames.indexOf(tag), 1)
    },
    remoteMethod(query) {
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          this.loading = false
          this.personInChargeList = this.list.filter(item => {
            return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1
          })
        }, 200)
      } else {
        this.options = []
      }
    },
    gutuser() {
      this.usernames = this.username
      this.form.attendees = this.usernames
    },
    sub(formName) {
      const THis = this
      if (!THis.form.estimate_start_time) {
        this.$message({
          message: '请选择时间',
          type: 'warning'
        })
        return
      }
      if (this.userList.length > 0) { //   参会人员
        this.$refs[formName].validate(valid => {
          if (valid) {
            const type_id = THis.form.type_id

            let convenor = ''
            if (typeof THis.form.convenor_user_ids === 'object') {
              convenor = {
                name: THis.form.convenor_user_ids.label,
                user_id: THis.form.convenor_user_ids.id,
                workcode: THis.form.convenor_user_ids.value
              }
            } else {
              convenor = THis.form.convenor
            }

            let host = ''
            let secretary = ''
            if (typeof THis.form.host_user_id === 'object') {
              host = {
                name: THis.form.host_user_id.label,
                user_id: THis.form.host_user_id.id,
                workcode: THis.form.host_user_id.value
              }
            } else {
              host = THis.form.host
            }
            if (typeof THis.form.secretary_user_id === 'object') {
              secretary = {
                name: THis.form.secretary_user_id.label,
                user_id: THis.form.secretary_user_id.id,
                workcode: THis.form.secretary_user_id.value
              }
            } else {
              secretary = THis.form.secretary
            }
            // 召集人和会议秘书不能是同一个人
            if (convenor.workcode === secretary.workcode) {
              this.$message.warning('召集人和会议秘书不可以是同一个人')
              return
            }

            const attendees = THis.userList.map(item => {
              return {
                name: item.name,
                user_id: item.userId,
                workcode: item.username
              }
            })

            const lssue = THis.form.lssue.filter(item => item.value).map(item => item.value)
            if (type_id !== 7 && lssue.length === 0) {
              this.$message.error('请输入会议议题！')
              return
            }

            const data = {
              subject: THis.form.subject,
              lssue: lssue,
              type_id: type_id,
              room_id: THis.form.room_id,
              describe: THis.form.describe,
              reminder_time: THis.form.reminder_time,
              estimate_start_time: THis.form.estimate_start_time,
              estimate_end_time: THis.form.estimate_end_time,
              secrecy_type: THis.form.secrecy_type,
              convenor: convenor,
              host: host,
              secretary: secretary,
              attendees: attendees,
              department_id: this.form.department_id,
              is_need_score: this.form.is_need_score
            }
            if (this.needDepart) {
              if (this.form.secretary_department_id === 0) {
                this.$message.error('请选择部门')
                return
              } else {
                data.secretary_department_id = this.form.secretary_department_id
              }
            } else {
              data.secretary_department_id = 0
            }
            if (type_id === 7) {
              data.night_estart_time = THis.form.night_estart_time
              data.night_eend_time = THis.form.night_eend_time
            }

            meetingupdate(data, this.$route.query.id)
              .then(response => {
                this.$alert('会议编辑成功', '提示', {
                  confirmButtonText: '查看会议详情'
                }).then(() => {
                  if (this.form.type_id === 7) { // 早会跳早会详情
                    this.$router.push({
                      name: 'morningDetails',
                      query: {
                        id: response.data.id
                      }
                    })
                  } else {
                    this.$router.push({
                      name: 'seeDetails',
                      query: {
                        id: response.data.id
                      }
                    })
                  }
                }).catch(() => {
                  console.log('关闭')
                })
              })
              .catch(error => {
                if (error.errors.attendees) {
                  let text = ''
                  for (const key in error.errors.attendees) {
                    const element = error.errors.attendees[key]
                    text += '<div>参会人：' + element.name + '【' + element.workcode + '】 ( 编号：' + element.meeting_id + ' )' + '</div>'
                  }
                  // 以下参会人员会议冲突（名称【工号】（编号：44,333）
                  this.$notify.error({
                    title: '以下参会人员会议冲突',
                    message: text,
                    dangerouslyUseHTMLString: true,
                    duration: 0,
                    customClass: 'alertClass'
                  })
                  console.log(error)
                }
              })
          } else {
            console.log('error submit!!')
            return false
          }
        })
      } else {
        this.$message({
          message: '请选择参会人员',
          type: 'warning'
        })
      }
    },
    read_json_only(dict_str) {
      for (const i in dict_str) {
        dict_str[i].Name = dict_str[i].udName
        if (typeof dict_str[i].children === 'object') {
          this.read_json_only(dict_str[i].children)
        }
      }
      this.tableList = dict_str
    },
    addDomain() {
      this.form.lssue.push({
        value: ''
      })
    },
    meetingTimeReload(time) {
      if (!this.desleb) {
        this.estimate_start_time = time.startTime
        this.estimate_end_time = time.endTime
        this.form.estimate_start_time = time.startTime
        this.form.estimate_end_time = time.endTime
      } else {
        alert('时间不能更改')
      }
    },
    removeDomain(item) {
      var index = this.form.lssue.indexOf(item)
      if (index !== -1) {
        this.form.lssue.splice(index, 1)
      }
    },
    roomChange() {
      this.room_id = this.form.room_id
    },
    selectUser() {
      this.selectObj = {
        visible: true,
        allUser: this.allUser,
        departTree: this.departTree,
        hasChoosed: this.userList,
        meeting_status: this.meeting_status,
        mettingUser: this.mettingUser// 已选择的
      }
    },
    saveUsre(params) {
      this.selectObj.visible = false
      this.userList = JSON.parse(JSON.stringify(params))
    },
    removeUser(index) {
      const isMetting_attendees = this.mettingUser.find(item => item.workcode === this.userList[index].workcode)
      if (isMetting_attendees && [1, 2, 5].includes(this.meeting_status)) {
        this.$message.error('进行中、已结束、决议处理中状态下不能删除原参会人')
        return
      }
      this.userList.splice(index, 1)
    },
    // 获取员工 0为全部数据
    getPerson(id) {
      this.allUser = []
      getDDusers(id).then(res => {
        if (res.code === '000000') {
          this.allUser = res.data
        }
      }).catch()
    },
    // 获取部门数据
    getDepart() {
      this.departTree = []
      getDepartTree().then(res => {
        if (res.code === '000000') {
          this.departTree = res.data
        }
      }).catch()
    }
  }
}

</script>

<style scope>
  .cente .cente_span {
    line-height: 1.7;
    display: block;
  }

  .fontsize14 {
    font-size: 14px;
  }

  .fdg {
    width: 48%;
    display: inline-block;
  }

  .grid-content {
    height: 230px;
    min-width: 900px;
    margin: 10px;
  }

  .bg {
    background: rebeccapurple !important;
  }

  ul {
    padding: 0;
    margin: 0;
  }

  .demo-form-inline {
    margin-top: 10px;
  }

  .el-notification {
    width: 700px !important;
  }

  .alertClass {
    width: 500px
  }
</style>
